import { Outlet } from 'react-router-dom';
import { Navbar } from 'src/routes/v2/navbarv2';

export function DashboardLayoutV2() {
  return (
    <main className="w-screen h-screen flex flex-col">
      <Navbar />
      <Outlet />
    </main>
  );
}
